import "./pTermsOfUse/pTermsOfUse.sass";

import { pTermsOfUseDirective } from './pTermsOfUse/pTermsOfUse.directive';

export default angular.module('frontend.termsOfUse', ["frontend.api", "frontend.auth", "frontend.theme"])
  .directive('pTermsOfUse', pTermsOfUseDirective);
